// src/store/modules/asterisk.js
const STORAGE_KEY = 'asterisk'

function loadPersisted() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    return raw ? JSON.parse(raw) : null
  } catch {
    localStorage.removeItem(STORAGE_KEY)
    return null
  }
}

export default {
  namespaced: true,

  state: () => ({
    asterisk: loadPersisted() // { database_id, db_name, db_ip, node_id, node_name, node_ip, contexts }
  }),

  getters: {
    hasScope: s => !!s.asterisk,
    databaseId: s => s.asterisk?.database_id ?? null,
    dbName: s => s.asterisk?.db_name ?? '',
    dbIp: s => s.asterisk?.db_ip ?? '',
    nodeId: s => s.asterisk?.node_id ?? null,
    nodeName: s => s.asterisk?.node_name ?? '',
    nodeIp: s => s.asterisk?.node_ip ?? '',
    contexts: s => s.asterisk?.contexts ?? []
  },

  mutations: {
    SET_ASTERISK(state, payload) {
      state.asterisk = payload ? { ...payload } : null
      if (payload) localStorage.setItem(STORAGE_KEY, JSON.stringify(payload))
      else localStorage.removeItem(STORAGE_KEY)
    }
  },

  actions: {
    setAsterisk({ commit }, payload) {
      commit('SET_ASTERISK', payload || null)
    },
    clearAsterisk({ commit }) {
      commit('SET_ASTERISK', null)
    }
  }
}
